import { jsx } from "panel";
import { PropertyValuesScreenEl } from "common/widgets/property-filter-menu/property-values-screen";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu";
import { ToggleEl } from "common/components/toggle";
import { ListOperator } from "common/widgets/property-filter-menu/models/types";
import { ToggleTheme } from "common/components/toggle/types";
export function template() {
  const { alwaysRender, keydownProxyEl, searchFilter, stagedPropertyFilter } = this.state;
  const PropertyValuesScreen = ({
    keydownProxyEl: keydownProxyEl2,
    stagedPropertyFilter: stagedPropertyFilter2
  }) => {
    return /* @__PURE__ */ jsx(PropertyValuesScreenEl, {
      attrs: this.helpers.serializeAttributes({
        "display-context": this.attr(`display-context`),
        "enable-enhanced-list-filters": this.attr(`enable-enhanced-list-filters`),
        "event-names": this.attr(`event-names`),
        "property-filter": stagedPropertyFilter2.getAttributes(),
        "has-back-button": true,
        "project-id": this.attr(`project-id`),
        "workspace-id": this.attr(`workspace-id`)
      }),
      on: {
        clickBack: this.helpers.onPropertyFilterBackClick,
        changePropertyFilter: this.helpers.onPropertyFilterChange,
        commitPropertyFilter: this.helpers.onPropertyFilterCommit
      },
      props: { keydownProxyEl: keydownProxyEl2 }
    });
  };
  const CohortOperatorSelect = ({ selectedCohortFilterOption }) => /* @__PURE__ */ jsx(ToggleEl, {
    sel: ".mp-filter-menu-cohort-options",
    attrs: {
      selected: selectedCohortFilterOption != null ? selectedCohortFilterOption : ListOperator.Contains,
      theme: ToggleTheme.SegmentedController,
      options: [
        {
          label: `Is`,
          value: ListOperator.Contains
        },
        {
          label: `Is Not`,
          value: ListOperator.DoesNotContain
        }
      ]
    },
    on: {
      select: (ev) => this.helpers.onCohortFilterOptionChange(ev.detail.selected)
    }
  });
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-filter-menu"
  }, this.attr(`open`) || alwaysRender ? !this.attr(`disable-value-selection`) && this.helpers.getSelectedPropertyFilter() ? /* @__PURE__ */ jsx(PropertyValuesScreen, {
    keydownProxyEl,
    stagedPropertyFilter
  }) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(PropertiesMenuEl, {
    attrs: this.helpers.serializeAttributes({
      "all-data-groups": this.attr(`all-data-groups`),
      "allow-typecast-pill-action": this.attr(`disable-value-selection`) ? `trigger-tutorial` : null,
      "enable-workspace-filter-restrictions": this.attr(`enable-workspace-filter-restrictions`),
      "exclude-dimension-properties": this.attr(`exclude-dimension-properties`),
      "exclude-lookup-table-properties": this.attr(`exclude-lookup-table-properties`),
      "event-names": this.attr(`event-names`),
      "include-custom-properties": this.attr(`include-custom-properties`),
      "data-group-id": this.attr(`data-group-id`),
      open: this.attr(`open`),
      "project-has-cohorts": this.attr(`project-has-cohorts`),
      "hide-events": this.attr(`hide-events`),
      "project-has-people": this.attr(`project-has-people`),
      "project-id": this.attr(`project-id`),
      "scd-poc-enabled": this.attr(`scd-poc-enabled`),
      readonly: this.attr(`readonly`),
      "search-filter": searchFilter,
      selected: this.helpers.getMenuSelection(),
      "hide-edit-controls": this.attr(`hide-edit-controls`),
      "show-all-tab": true,
      "show-special-dataset-property": this.attr(`show-special-dataset-property`),
      "support-b2b-cohorts": this.attr(`support-b2b-cohorts`),
      "inline-cohorts-override": this.attr(`inline-cohorts-override`),
      "cohort-operation-type": `filter`,
      "cohort-multiselect": true,
      "user-id": this.attr(`user-id`),
      "workspace-id": this.attr(`workspace-id`),
      "track-name": this.attr(`track-name`),
      "other-options": this.attr(`other-filter-options`),
      "apply-button-text": `Add Filter`,
      "min-selection": 1,
      "disabled-items": this.attr(`disabled-items`)
    }),
    params: {
      listProperty: this.params.listProperty
    },
    hook: { insert: this.helpers.onMenuInserted },
    on: {
      deletecustomproperty: this.helpers.propagateEvent,
      closedModal: this.helpers.propagateEvent,
      openedModal: this.helpers.propagateEvent,
      select: this.helpers.handlePropertySelect,
      selectoption: this.helpers.handlePropertySelectOption,
      track: this.helpers.preventTracking,
      stagedproperty: this.helpers.handleStageChange
    },
    props: {
      context: `filter`,
      keydownProxyEl
    }
  }, this.helpers.isCohortSelection() && /* @__PURE__ */ jsx("div", {
    sel: ".mp-filter-menu-header",
    attrs: { slot: `menu-header` },
    class: { "is-visible": this.helpers.isCohortSelection() }
  }, /* @__PURE__ */ jsx(CohortOperatorSelect, {
    selectedCohortFilterOption: this.state.selectedCohortFilterOption
  })))) : null);
}
